import { defineAction } from '~/prix'
import { z } from 'zod'
import trainingUpdateAction from './trainingUpdate.action.json' with { type: 'json' }
import { trainingObject } from '../trainingObject'
import { dateOrIsoString } from '~/prix/types/date'

const trainingUpdateDefinition = defineAction({
  ...trainingUpdateAction,

  input: z.object({
    id: trainingObject.shape.id,
    type: z.string().optional(),
    title: z.string().optional(),
    observation: z.string().nullable().optional(),
    updatedAt: dateOrIsoString().nullish(),
  }),
  output: z.object({}),
})

export default trainingUpdateDefinition
